// extracted by mini-css-extract-plugin
export default {"wrapper":"QuoteText_wrapper__-t81p","divider":"QuoteText_divider__5P2HO","text":"QuoteText_text__qSA5s"};